(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6950],{

/***/ 43784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent",
      function () {
        return __webpack_require__(46749);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ CardHighlight01; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/CardHighlight01/CardHighlight01.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fff1bf;\n  color: #433f52;\n  padding: 2rem;\n  font-size: ",
        ";\n  border-radius: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31cf8314-0"
})(_templateObject(), (0,theme/* fontSize */.JB)("md"));
var CardHighlight01Styles = {
    Root: Root
};

;// CONCATENATED MODULE: ./components/CardHighlight01/CardHighlight01.tsx





var CardHighlight01 = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight01Styles.Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        children: children
    }));
};


/***/ }),

/***/ 34039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ CardHighlight04; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/CardHighlight04/CardHighlight04.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #bcf3e5;\n  color: #03585a;\n  padding: 1.5rem;\n  font-size: ",
        ";\n  border-radius: 2.5rem;\n\n  @media (min-width: ",
        ") {\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-202cdf46-0"
})(_templateObject(), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"));
var CardHighlight04Styles = {
    Root: Root
};

;// CONCATENATED MODULE: ./components/CardHighlight04/CardHighlight04.tsx





var CardHighlight04 = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight04Styles.Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        children: children
    }));
};


/***/ }),

/***/ 40176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ HashAnchor; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
;// CONCATENATED MODULE: ./components/HashAnchor/HashAnchor.contants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_TOP_MARGIN_IN_PIXELS = -50;

;// CONCATENATED MODULE: ./components/HashAnchor/HashAnchor.tsx



var HashAnchor = function(param) {
    var name = param.name, _top = param.top, top = _top === void 0 ? DEFAULT_TOP_MARGIN_IN_PIXELS : _top;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
        name: name,
        id: name,
        style: {
            position: "relative",
            top: "".concat(top, "px"),
            display: "block",
            visibility: "hidden"
        }
    });
};

;// CONCATENATED MODULE: ./components/HashAnchor/index.ts



/***/ }),

/***/ 46749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ talent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/CardHighlight03/CardHighlight03.tsx + 1 modules
var CardHighlight03 = __webpack_require__(13917);
// EXTERNAL MODULE: ./components/HashAnchor/index.ts + 2 modules
var HashAnchor = __webpack_require__(40176);
// EXTERNAL MODULE: ./components/layout/Page.styled.tsx
var Page_styled = __webpack_require__(29242);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/public-talent/components/intro/TalentIntro.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: 0 auto 3rem auto;\n\n  h2 {\n    margin-top: 0;\n    font-size: ",
        ";\n    text-wrap: balance;\n  }\n\n  p {\n    font-size: ",
        ";\n    line-height: 1.75;\n    margin: 0 auto;\n  }\n\n  p:first-child {\n    font-size: ",
        ";\n    font-weight: 800;\n    margin-bottom: 0;\n  }\n\n  p:last-child {\n    margin: 0 auto;\n  }\n\n  @media (min-width: ",
        ") {\n    text-align: center;\n\n    h2 {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9349de47-0"
})(_templateObject(), (0,theme/* container */.nC)("lg"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl4"));
var TalentIntroStyles = {
    Root: Root
};

;// CONCATENATED MODULE: ./features/public-talent/components/intro/TalentIntro.tsx






var TalentIntro = function(_param) {
    var title = _param.title, desc = _param.desc, prepend = _param.prepend, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "desc",
        "prepend"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentIntroStyles.Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        children: [
            prepend && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: prepend
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                editorial: true,
                as: "h2",
                size: "5xl",
                children: title
            }),
            desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: desc
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./features/public-talent/cv/TalentCV.styles.ts

function TalentCV_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #faf9ff;\n  color: #433f52;\n  padding: 24px 1rem;\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n\n  @media (min-width: ",
        ") {\n    padding: 64px 0;\n  }\n\n  .intro {\n    margin-bottom: 2rem;\n\n    @media (min-width: ",
        ") {\n      max-width: 70%;\n      margin-left: auto;\n      margin-right: auto;\n\n      &.full {\n        max-width: 100%;\n      }\n    }\n  }\n"
    ]);
    TalentCV_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  line-height: 1.75;\n  font-size: ",
        ";\n\n  h3 {\n    font-size: ",
        ";\n    line-height: 1.25;\n    margin-bottom: 0;\n  }\n\n  img {\n    max-width: 100%;\n    margin: 0 auto;\n  }\n\n  p {\n    margin-bottom: 0.75rem;\n    line-height: 1.5;\n  }\n\n  ul {\n    margin: 0 0 1.5rem 0;\n  }\n\n  li {\n    background: url(/images/companies-new/companies-new-bullet.svg) no-repeat 0\n      0.35rem;\n    padding-left: 1.75rem;\n    margin-bottom: 0.25rem;\n  }\n\n  &.no-list-style li {\n    padding-left: 0;\n    background: none;\n    list-style-type: disc;\n    margin-left: 1.5rem;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    gap: 4rem;\n    font-size: ",
        ";\n\n    h3 {\n      font-size: ",
        ";\n    }\n\n    img {\n      max-width: 40%;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var TalentCV_styles_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce1c06de-0"
})(TalentCV_styles_templateObject(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"));
var CardContent1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ce1c06de-1"
})(_templateObject1(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("xl3"));
var TalentCVStyles = {
    Root: TalentCV_styles_Root,
    CardContent1: CardContent1
};

;// CONCATENATED MODULE: ./features/public-talent/cv/TalentCV.tsx












var TalentCV = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-new").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentCVStyles.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
            direction: "column",
            gap: "4xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
                containerSize: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentIntro, {
                        className: "intro",
                        title: t("talent-new.cv.title"),
                        desc: t("talent-new.cv.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                        direction: "column",
                        gap: "4xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HashAnchor/* HashAnchor */.v, {
                                name: "professional_profile"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight03/* CardHighlight03 */.u, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentCVStyles.CardContent1, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-features-feature1.webp"),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.cv.feature1.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.cv.feature1.card-content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.getmanfred.com/blog/como-hacer-un-perfil-perfecto-en-manfred",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                        schema: "brand1",
                                                        variant: "hard",
                                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW,
                                                        size: "s",
                                                        label: t("talent-new.cv.feature1.cta")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight03/* CardHighlight03 */.u, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentCVStyles.CardContent1, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-features-feature2.webp"),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.cv.feature2.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.cv.feature2.card-content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.getmanfred.com/blog/importar-tus-datos-de-linkedin",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                        schema: "brand1",
                                                        variant: "hard",
                                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW,
                                                        size: "s",
                                                        label: t("talent-new.cv.feature2.cta")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var cv_TalentCV = (TalentCV);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./features/public-talent/hero/TalentHero.styled.ts

function TalentHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #d3d9f3;\n  color: #0a053a;\n  padding: 4rem 0 5rem 0;\n  font-size: ",
        ";\n\n  .titles {\n    flex-direction: column-reverse;\n  }\n"
    ]);
    TalentHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TalentHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('/images/talent-new/talent-new-hero-bg.svg') no-repeat top\n    center;\n  background-size: cover;\n  padding: 3rem 1rem;\n  margin-top: 2rem;\n\n  color: #0a053a;\n\n  text-align: center;\n\n  p {\n    margin: 0;\n  }\n\n  h1 {\n    font-size: ",
        " !important;\n    font-weight: 800;\n    text-wrap: balance;\n    margin: 0 0 1.5rem 0;\n  }\n\n  @media (min-width: ",
        ") {\n    padding: 80px 0 100px 0;\n    background-size: cover;\n    text-align: left;\n\n    h1 {\n      font-size: ",
        " !important;\n      font-weight: 800;\n      margin-top: 3rem;\n    }\n  }\n"
    ]);
    TalentHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 1rem;\n  padding: 0;\n  max-width: 100%;\n  margin: 0 auto;\n  align-items: center;\n\n  img {\n    margin: 0 auto;\n    max-width: 100%;\n  }\n\n  br {\n    display: none;\n  }\n\n  @media (min-width: ",
        ") {\n    margin: 0 auto;\n    max-width: 50%;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row-reverse;\n    gap: 3rem;\n    padding: 0 6rem;\n    max-width: 100%;\n    margin: 0;\n\n    br {\n      display: block;\n    }\n\n    img {\n      max-width: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var TalentHero_styled_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f0d03ed-0"
})(TalentHero_styled_templateObject(), (0,theme/* fontSize */.JB)("lg"));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f0d03ed-1"
})(TalentHero_styled_templateObject1(), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* screen */.sp)("xl"), (0,theme/* fontSize */.JB)("xl5"));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f0d03ed-2"
})(_templateObject2(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("xl"));
var CTAs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f0d03ed-3"
})(_templateObject3(), (0,theme/* screen */.sp)("xl"));
var Hero = {
    Root: TalentHero_styled_Root,
    Wrapper: Wrapper,
    Content: Content,
    CTAs: CTAs
};

;// CONCATENATED MODULE: ./features/public-talent/hero/TalentHero.tsx










var TalentHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-new").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page_styled/* PageContentContainer */.R, {
            containerSize: "xlMax",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                            editorial: true,
                                            as: "h1",
                                            size: "5xl",
                                            children: t("talent-new.hero.title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                            ns: "talent-new",
                                            i18nKey: "talent-new.hero.subtitle"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero.CTAs, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale),
                                        schema: "brand1",
                                        variant: "hard",
                                        label: t("talent-new.hero.cta1"),
                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-hero-image.webp"),
                                alt: "Talent",
                                width: "570",
                                height: "500"
                            })
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./components/CardHighlight02/CardHighlight02.tsx + 1 modules
var CardHighlight02 = __webpack_require__(18408);
;// CONCATENATED MODULE: ./features/public-talent/offers/TalentOffers.styles.ts

function TalentOffers_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #faf9ff;\n  color: #433f52;\n  padding: 24px 1rem;\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n\n  @media (min-width: ",
        ") {\n    padding: 64px 0;\n  }\n\n  .intro {\n    margin-bottom: 2rem;\n\n    @media (min-width: ",
        ") {\n      max-width: 70%;\n      margin-left: auto;\n      margin-right: auto;\n\n      &.full {\n        max-width: 100%;\n      }\n    }\n  }\n"
    ]);
    TalentOffers_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TalentOffers_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  line-height: 1.75;\n  font-size: ",
        ";\n\n  h3 {\n    font-size: ",
        ";\n    line-height: 1.25;\n    margin-bottom: 0;\n  }\n\n  img {\n    max-width: 100%;\n    margin: 0 auto;\n  }\n\n  p {\n    margin-bottom: 0.75rem;\n    line-height: 1.5;\n  }\n\n  ul {\n    margin: 0;\n  }\n\n  li {\n    background: url(/images/companies-new/companies-new-bullet.svg) no-repeat 0\n      0.35rem;\n    padding-left: 1.75rem;\n    margin-bottom: 0.25rem;\n  }\n\n  &.no-list-style li {\n    padding-left: 0;\n    background: none;\n    list-style-type: disc;\n    margin-left: 1.5rem;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    gap: 4rem;\n    font-size: ",
        ";\n\n    h3 {\n      font-size: ",
        ";\n    }\n\n    img {\n      max-width: 40%;\n    }\n  }\n"
    ]);
    TalentOffers_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TalentOffers_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.75;\n\n  img {\n    margin-bottom: 2rem;\n  }\n\n  h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: ",
        ";\n    font-weight: 700;\n    line-height: 1.25;\n  }\n\n  p {\n    margin-top: 0;\n    font-size: ",
        ";\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    max-width: ",
        ";\n    text-align: ",
        ";\n    margin: 0 auto;\n\n    h3 {\n      font-size: ",
        ";\n    }\n\n    p {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    TalentOffers_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var TalentOffers_styles_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5ff1b81-0"
})(TalentOffers_styles_templateObject(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"));
var TalentOffers_styles_CardContent1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5ff1b81-1"
})(TalentOffers_styles_templateObject1(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("xl3"));
var CardContent2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5ff1b81-2"
})(TalentOffers_styles_templateObject2(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), function(param) {
    var align = param.align;
    return align === "center" ? "55%" : "100%";
}, function(param) {
    var align = param.align;
    return align || "left";
}, (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontSize */.JB)("lg"));
var TalentOffersStyles = {
    Root: TalentOffers_styles_Root,
    CardContent1: TalentOffers_styles_CardContent1,
    CardContent2: CardContent2
};

;// CONCATENATED MODULE: ./features/public-talent/offers/TalentOffers.tsx














var TalentOffers = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-new").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentOffersStyles.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
            direction: "column",
            gap: "4xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
                containerSize: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentIntro, {
                        className: "intro",
                        title: t("talent-new.offers.title"),
                        desc: t("talent-new.offers.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                        direction: "column",
                        gap: "4xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight03/* CardHighlight03 */.u, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentOffersStyles.CardContent1, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-offers-feature1.webp"),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.offers.feature1.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.offers.feature1.card-content"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight02/* CardHighlight02 */.e, {
                                        className: "half",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentOffersStyles.CardContent2, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    loading: "lazy",
                                                    src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-offers-feature2.webp"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.offers.feature2.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.offers.feature2.card-content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.jobOffers */.uu.jobOffers, locale),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                        schema: "brand1",
                                                        variant: "hard",
                                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW,
                                                        size: "s",
                                                        label: t("talent-new.offers.feature2.cta")
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight02/* CardHighlight02 */.e, {
                                        className: "half",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentOffersStyles.CardContent2, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    loading: "lazy",
                                                    src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-offers-feature3.webp"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.offers.feature3.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.offers.feature3.card-content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.manfredDaily */.uu.manfredDaily, locale),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                        schema: "brand1",
                                                        variant: "hard",
                                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW,
                                                        size: "s",
                                                        label: t("talent-new.offers.feature3.cta")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var offers_TalentOffers = (TalentOffers);

;// CONCATENATED MODULE: ./features/public-talent/recruiting/TalentRecruiting.styles.ts

function TalentRecruiting_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #faf9ff;\n  color: #433f52;\n  padding: 24px 1rem;\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n\n  @media (min-width: ",
        ") {\n    padding: 64px 0;\n  }\n\n  .intro {\n    margin-bottom: 2rem;\n\n    @media (min-width: ",
        ") {\n      margin-left: auto;\n      margin-right: auto;\n\n      &.full {\n        max-width: 100%;\n      }\n    }\n  }\n"
    ]);
    TalentRecruiting_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TalentRecruiting_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #92e6d7;\n  color: #087273;\n  border-radius: 20px;\n  padding: 2rem 3rem 1rem 3rem;\n  transform: translate(0px, 0px) rotate(2deg);\n  border-radius: 45% 25% 45% 25% / 42% 16% 33% 20%;\n\n  > div {\n    transform: translate(0px, 0px) rotate(-2deg);\n    font-size: ",
        ";\n    text-align: center;\n  }\n\n  .title {\n    font-size: ",
        ";\n    text-align: center;\n    justify-content: center;\n\n    em {\n      background: #087273;\n      color: #92e6d7;\n      padding: 0.25rem 0.5rem;\n      border-radius: 20px;\n      text-transform: lowercase;\n      font-size: ",
        ";\n      font-weight: bold;\n      font-style: normal;\n      min-width: 30px;\n    }\n\n    strong {\n      min-width: 80%;\n    }\n\n    span {\n      min-width: 80%;\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n\n      span {\n        text-align: left;\n      }\n\n      strong {\n        text-align: right;\n      }\n    }\n  }\n"
    ]);
    TalentRecruiting_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var TalentRecruiting_styles_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e44fc57f-0"
})(TalentRecruiting_styles_templateObject(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"));
var TalentRecruiting_styles_CardContent1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e44fc57f-1"
})(TalentRecruiting_styles_templateObject1(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl"));
var TalentRecruitingStyles = {
    Root: TalentRecruiting_styles_Root,
    CardContent1: TalentRecruiting_styles_CardContent1
};

;// CONCATENATED MODULE: ./features/public-talent/recruiting/TalentRecruiting.tsx







var TalentRecruiting = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-new").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentRecruitingStyles.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
            direction: "column",
            gap: "4xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
                containerSize: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentIntro, {
                        className: "intro",
                        title: t("talent-new.recruiting.title"),
                        desc: t("talent-new.recruiting.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                        direction: "column",
                        gap: "l",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page_styled/* PageContentContainer */.R, {
                            containerSize: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                                direction: "column",
                                gap: "4xl",
                                children: Array.from({
                                    length: 4
                                }).map(function(_, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentRecruitingStyles.CardContent1, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                                    className: "title",
                                                    alignment: "center",
                                                    gap: "s",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: t("talent-new.recruiting.feature".concat(index + 1, ".pro"))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: t("talent-new.recruiting.vs")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: t("talent-new.recruiting.feature".concat(index + 1, ".con"))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.recruiting.feature".concat(index + 1, ".desc")
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var recruiting_TalentRecruiting = (TalentRecruiting);

// EXTERNAL MODULE: ./components/CardHighlight01/CardHighlight01.tsx + 1 modules
var CardHighlight01 = __webpack_require__(80439);
// EXTERNAL MODULE: ./components/CardHighlight04/CardHighlight04.tsx + 1 modules
var CardHighlight04 = __webpack_require__(34039);
;// CONCATENATED MODULE: ./features/public-talent/tools/TalentTools.styles.ts

function TalentTools_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #faf9ff;\n  color: #433f52;\n  padding: 24px 1rem;\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n\n  @media (min-width: ",
        ") {\n    padding: 64px 0;\n  }\n\n  .intro {\n    margin-bottom: 2rem;\n\n    @media (min-width: ",
        ") {\n      max-width: 70%;\n      margin-left: auto;\n      margin-right: auto;\n\n      &.full {\n        max-width: 100%;\n      }\n    }\n  }\n"
    ]);
    TalentTools_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TalentTools_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.75;\n\n  h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: ",
        ";\n    font-weight: 700;\n    line-height: 1.25;\n  }\n\n  p {\n    margin-top: 0;\n    font-size: ",
        ";\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    max-width: ",
        ";\n    text-align: ",
        ";\n    margin: 0 auto;\n\n    h3 {\n      font-size: ",
        ";\n    }\n\n    p {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    TalentTools_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TalentTools_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.75;\n\n  img {\n    margin-bottom: 2rem;\n  }\n\n  h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: ",
        ";\n    font-weight: 700;\n    line-height: 1.25;\n  }\n\n  p {\n    margin-top: 0;\n    font-size: ",
        ";\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    max-width: ",
        ";\n    text-align: ",
        ";\n    margin: 0 auto;\n\n    h3 {\n      font-size: ",
        ";\n    }\n\n    p {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    TalentTools_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var TalentTools_styles_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dac41515-0"
})(TalentTools_styles_templateObject(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"));
var TalentTools_styles_CardContent1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dac41515-1"
})(TalentTools_styles_templateObject1(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), function(param) {
    var align = param.align;
    return align === "center" ? "55%" : "100%";
}, function(param) {
    var align = param.align;
    return align || "left";
}, (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontSize */.JB)("lg"));
var TalentTools_styles_CardContent2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dac41515-2"
})(TalentTools_styles_templateObject2(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), function(param) {
    var align = param.align;
    return align === "center" ? "55%" : "100%";
}, function(param) {
    var align = param.align;
    return align || "left";
}, (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontSize */.JB)("lg"));
var TalentToolsStyles = {
    Root: TalentTools_styles_Root,
    CardContent1: TalentTools_styles_CardContent1,
    CardContent2: TalentTools_styles_CardContent2
};

;// CONCATENATED MODULE: ./features/public-talent/tools/TalentTools.tsx














var TalentTools = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-new").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentToolsStyles.Root, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
            direction: "column",
            gap: "4xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* PageContentContainer */.R, {
                containerSize: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentIntro, {
                        className: "intro",
                        title: t("talent-new.tools.title"),
                        desc: t("talent-new.tools.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                        direction: "column",
                        gap: "4xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight01/* CardHighlight01 */.D, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentToolsStyles.CardContent1, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-tools-feature1.webp"),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.tools.feature1.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.tools.feature1.card-content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.salaryBenchmark */.uu.salaryBenchmark, locale),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                        schema: "brand1",
                                                        variant: "hard",
                                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW,
                                                        size: "s",
                                                        label: t("talent-new.tools.feature1.cta")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight04/* CardHighlight04 */.Q, {
                                        className: "half",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentToolsStyles.CardContent2, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    loading: "lazy",
                                                    src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-tools-feature2.webp"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.tools.feature2.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.tools.feature2.card-content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.mantechcar25 */.uu.mantechcar25, locale),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                        schema: "brand1",
                                                        variant: "hard",
                                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW,
                                                        size: "s",
                                                        label: t("talent-new.tools.feature2.cta")
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight04/* CardHighlight04 */.Q, {
                                        className: "half",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentToolsStyles.CardContent2, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    loading: "lazy",
                                                    src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-tools-feature3.webp"),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.tools.feature3.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.tools.feature3.card-content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.helpingJuniors */.uu.helpingJuniors, locale),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                        schema: "brand1",
                                                        variant: "hard",
                                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW,
                                                        size: "s",
                                                        label: t("talent-new.tools.feature3.cta")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHighlight01/* CardHighlight01 */.D, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentToolsStyles.CardContent1, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: (0,paths/* getPublicPath */.A)("/images/talent-new/talent-new-tools-feature4.webp"),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* StackItem */.vO, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: t("talent-new.tools.feature4.card-title")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "talent-new",
                                                    i18nKey: "talent-new.tools.feature4.card-content"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Settings */.uu.portalV2Settings, locale),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                                        schema: "brand1",
                                                        variant: "hard",
                                                        endIcon: pro_solid_svg_icons/* faArrowRight */.eFW,
                                                        size: "s",
                                                        label: t("talent-new.tools.feature1.cta")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var tools_TalentTools = (TalentTools);

;// CONCATENATED MODULE: ./features/public-talent/TalentPage.tsx

function TalentPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a > span > span {\n    white-space: wrap;\n  }"
    ]);
    TalentPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var TalentPage = function() {
    var t = (0,useI18n/* useI18n */.Q)("talent-new").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    var TalentGlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(TalentPage_templateObject());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentGlobalStyles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("talent-new.page_title"),
                desc: t("talent-new.page_description"),
                url: app_urls/* APP_URLS.talent */.uu.talent,
                imgUrl: "".concat((0,paths/* getPublicPath */.A)("/images/cards/card_talent_new.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
                hasScrollTop: true,
                pageVariant: "midnight_light",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                    direction: "column",
                    gap: "3xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TalentHero, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cv_TalentCV, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(offers_TalentOffers, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(recruiting_TalentRecruiting, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tools_TalentTools, {})
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/talent.tsx

var __N_SSG = true;
/* harmony default export */ var talent = (TalentPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,5890,9774,2888,179], function() { return __webpack_exec__(43784); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);